'use client';

export const ChevronRight = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M20.8294 16.0021L9.32548 4.85569C9.10555 4.64284 8.99708 4.38689 9.00006 4.08785C9.00279 3.78856 9.11413 3.53248 9.33406 3.31964C9.55374 3.10654 9.81803 3 10.1269 3C10.4356 3 10.6999 3.10654 10.9198 3.31964L22.3063 14.3603C22.5471 14.5936 22.7229 14.8537 22.8337 15.1407C22.9446 15.428 23 15.7151 23 16.0021C23 16.2891 22.9446 16.5763 22.8337 16.8635C22.7229 17.1505 22.5471 17.4107 22.3063 17.644L10.9109 28.6846C10.6912 28.8977 10.4284 29.0028 10.1225 28.9999C9.81654 28.9973 9.55374 28.8894 9.33406 28.6763C9.11413 28.4635 9.00416 28.2074 9.00416 27.9081C9.00416 27.6091 9.11413 27.353 9.33406 27.1399L20.8294 16.0021Z"
				fill="currentColor"
			/>
		</svg>
	);
};
